const URL_BASE=process.env.REACT_APP_API;

export const URL_GENDERS_LIST=`${URL_BASE}/gender`;